// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","3758":"182128fd","7792":"d315dd8c","9680":"b69271d9"}[chunkId] + ".chunk.css";
};